<template>
  <li
    class="d-flex flex-column justify-content-between"
    @click="goTo(item)"
    v-if="visible(item)"
    v-c-emit-root-event:open-modal-preview="item"
  >
    <span v-if="hasHTMLBuilderData" class="flags">
      <b></b>
      <i>Arpoone</i>
    </span>
    <img
      :src="item.thumbnailUri"
      alt="Nome do template"
      v-if="item.thumbnailUri"
      class="crop"
    />
    <img
      :src="require('@/assets/imgs/model.png')"
      alt="Nome do template"
      v-else
    />
    <p class="text-center mt-2">{{ item.name }}</p>
  </li>
</template>

<script>
export default {
  name: 'ItemViewtemplate',
  props: {
    item: {
      type: Object,
      default: function() {}
    }
  },
  data() {
    return {}
  },
  computed: {
    hasHTMLBuilderData() {
      if (!this.item?.htmlBuilderData) return false

      return Object.keys(this.item.htmlBuilderData).length !== 0
    }
  },
  methods: {
    goTo(item) {
      if (item.link) {
        this.$router.push(item.link)
      }
    },
    visible(item) {
      if (!item.alwaysVisible) {
        if (!item.alwaysVisible && this.$route.params.campaignId) {
          return true
        }
        return false
      }

      return true
    }
  }
}
</script>

<style lang="scss" scoped>
.flags {
  position: relative;
  b {
    position: absolute;
    left: 0;
    width: 0;
    height: 0;
    border-top: 88px solid $primary;
    border-right: 88px solid transparent;
  }

  i {
    transform: rotate(-45deg);
    color: $white;
    position: absolute;
    left: 0;
    top: 18px;
    font-weight: bold;
    font-size: 14px;
  }
}

li {
  padding: 0.5rem;
  max-width: 270px;
  position: relative;
  img {
    border: 1px solid transparent;
    transition: 300ms;

    &.crop {
      width: 270px;
      height: 275px;
      object-fit: cover;
    }
  }

  p {
    color: var(--gray-700);
  }

  &:hover {
    cursor: pointer;

    img {
      border-color: var(--primary);
      box-shadow: 0px 7px 13px 0 rgba(34, 37, 43, 0.16);
    }

    p {
      color: var(--gray-base);
    }
  }
}
</style>
